import { render, staticRenderFns } from "./VerifiedEmail.vue?vue&type=template&id=1b4065b9&"
import script from "./VerifiedEmail.vue?vue&type=script&lang=js&"
export * from "./VerifiedEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports